import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/store/modules/auth/'
import pets from '@/store/modules/pets/'
import admin from '@/store/modules/admin/'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['auth', 'candidates']
});

export default new Vuex.Store({
  state: {
    activeLoading: false,
    loadingPageMsg: ''
  },
  mutations: {
    setLoading (state, { isLoading, msg }) {
      state.activeLoading = isLoading;
      state.loadingPageMsg = msg;
    }
  },
  actions: {
  },
  modules: {
    auth,
    pets,
    admin
  },
  plugins: [vuexLocal.plugin]
})
